/* æçº¿å¾ */
import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { Router } from '@angular/router';
@Component({
    selector: 'fc-chartline',
    template: `
    <ngx-charts-line-chart
        [view]="fcView"
        [scheme]="fcScheme"
        [results]="fcData"
        [gradient]="_gradient"
        [xAxis]="_showXAxis"
        [yAxis]="_showYAxis"
        [legend]="_showLegend"
        [legendTitle]="fcLegendTitle"
        [showXAxisLabel]="_showXAxisLabel"
        [showYAxisLabel]="_showYAxisLabel"
        [xAxisLabel]="fcXAxisLabel"
        [yAxisLabel]="fcYAxisLabel"
        [autoScale]="_autoScale"
        (select)="_select($event)"
        (activate)="_activate($event)"
        (deactivate)="_deactivate($event)">
    </ngx-charts-line-chart>
    `,
    styles: [`
    `]
})
export class FcchartlineComponent extends FcinputComponent {
     /**éç½®å¾è¡¨æ°æ®*/
    @Input()
    fcData: any[] = [];
     /**è§å¾å¤§å°,number[]å,å¦æä¸ä¼ ç»§æ¿ç¶çº§çå®½é«*/
    @Input()
    fcView: number[] = [];
     /**å¾è¡¨çéè²æ¹æ¡*/
    @Input()
    fcScheme: any = {};
     /**å¾è¡¨çèªå®ä¹é¢è²ãç¨äºè¦çç¹å®å¼çé¢è²*/
    fcCustomColors: any = {}
     /** æ¾ç¤ºæéèxè½´*/
    @Input()
    fcShowXAxis: string;
    _showXAxis: boolean = true;
     /**æ¾ç¤ºæéèyè½´*/
    @Input()
    fcShowYAxis: string;
    _showYAxis: boolean = true;
     /**æ¯å¦æ¸åå¡«ååç´ èä¸æ¯çº¯è²*/
    @Input()
    fcGradient: string;
    _gradient: boolean = true;
     /**æ¾ç¤ºæéèå¾ä¾*/
    @Input()
    fcShowLegend: string;
    _showLegend: boolean = true;
     /** æ¾ç¤ºæéèxè½´æ ç­¾*/
    @Input()
    fcShowXAxisLabel: string;
    _showXAxisLabel: boolean = true;
     /** æ¾ç¤ºæéèyè½´æ ç­¾*/
    @Input()
    fcShowYAxisLabel: string;
    _showYAxisLabel: boolean = true;
     /**xè½´æ ç­¾æå­*/
    @Input()
    fcXAxisLabel: string;
     /**yè½´æ ç­¾æå­*/
    @Input()
    fcYAxisLabel: string;
     /**æ¯å¦æ¯ç©ºå¿åï¼é»è®¤æ¯ç©ºå¿å*/
    @Input()
    fcDoughnut: string;
    _doughnut: boolean = true;
     /**æ±ç¶å¾ç±»å,åæ¬æç°å¾'default',æå°'advanced',é¢ç§¯'grid'ï¼å ç§¯é¢ç§¯'grid'ï¼å½ä¸åé¢ç§¯'grid'*/
    @Input()
    fcType: string;
     /**æ¯å¦èªå¨æ¾å¤§ç¼©å°*/
    _autoScale: boolean = true;
     /**å¾ä¾æ é¢*/
    @Input()
    fcLegendTitle:string;
    constructor(public provider: ProvidersService, private router: Router) {
        super(provider, 'fc-chartline');
    }
    _afterParentInit() {

    }
    /**
 * éä¸­ 
 * @param event 
 */
    _activate(event) {
        this.event('activate', event);
    }
    /**
     * åç´ æ¿æ´»äºä»¶ï¼é¼ æ è¾å¥ï¼
     * @param event 
     */
    _deactivate(event) {
        this.event('deactivate', event);
    }
    /**
    * åç´ åç¨äºä»¶ï¼é¼ æ ç¦»å¼ï¼
    * @param event 
    */
    _select(event) {
        this.event('select', event);
    }
}
